<template>
  <router-link class="menu-notification" :to="{ name: 'chat' }">
    <BaseIcon icon="chat-main" />
    <div
      v-if="countNewNotifications > 0"
      :data-text="countNewNotifications"
      class="menu-notification_badge f12"
    />
  </router-link>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'HeaderChat',
  data() {
    return {
      firstLoad: false,
    }
  },
  computed: {
    ...mapState(['apiDomain']),
    ...mapState('chat', ['chatsList']),
    ...mapGetters('notificationUser', ['notificationUserGrid']),
    ...mapGetters('user', ['userData']),
    countNewNotifications() {
      return this.chatsList.reduce((sum, chat) => sum + Number(chat?._count?.messages), 0)
    },
  },
  methods: {
    ...mapActions('notificationUser', ['onNotificationUserGrid']),
  },
}
</script>

<style lang="scss" scoped>
.menu-notification {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  &_badge {
    position: absolute;
    left: 55%;
    top: 35%;
    transform: translateY(-50%);
    &::before {
      background: #f2f2f2;
      border-radius: 50%;
      min-width: 22px;
      content: attr(data-text);
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 3px;
      color: #333333;
      border: 2px solid #277faf;
    }
  }
  &.router-link-active {
    &::before {
      content: '';
      height: 3px;
      background: #ffffff;
      width: 50%;
      max-width: 69px;
      position: absolute;
      transform: translateX(-50%);
      left: 50%;
      bottom: 0;
    }
  }
  &:hover {
    background-color: #3d8cb7;
  }
}
</style>
